const API_BASE_URL = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ?? ''
const FUNCTIONS_BASE = `${API_BASE_URL}/.netlify/functions`

const buildSearchParams = (params = {}) => {
  const search = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '' || (Array.isArray(value) && !value.length)) {
      return
    }
    if (Array.isArray(value)) {
      search.set(key, value.join(','))
      return
    }
    search.set(key, value)
  })
  return search
}

export const searchProperties = async (params = {}, { signal } = {}) => {
  const query = buildSearchParams(params)
  const url = `${FUNCTIONS_BASE}/properties${query.toString() ? `?${query}` : ''}`
  const response = await fetch(url, { signal })
  if (!response.ok) {
    const message = await response.text().catch(() => '')
    throw new Error(message || `Search failed (${response.status})`)
  }
  return response.json()
}
